var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"h-20 w-20 cursor-pointer",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.onChange}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }